/**
 * @file The Insight Available Hours component.
 * @author Heino Lenting
*/
import * as tslib_1 from "tslib";
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { DomainService } from '../../domain.service';
import { LocalisationService } from '../../core/localisation.service';
import { InsightProvider } from '../insight-provider';
import { InsightService } from '../insight.service';
import { InsightTableComponent } from '../../insights/insight-table/insight-table.component';
import { ComponentRegistry } from '../../core/component-registry';
import { ResourceService } from '../../resource.service';
import { AlertsService } from '../../core/alerts.service';
import { EventsService } from '../../core/event.service';
var InsightAvailableHoursComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InsightAvailableHoursComponent, _super);
    /**
     * Constructs an InsightAvailableHoursComponent.
     * @param configurationsService A service that manages the configuration for components.
     * @param provider A provider that contains extra information such as configuration data.
     */
    function InsightAvailableHoursComponent(resourceService, provider, insightService, localisationService, router, domainService, translateService, alertsService, eventsService) {
        var _this = _super.call(this, resourceService, provider, insightService, localisationService, alertsService, eventsService) || this;
        _this.translateService = translateService;
        _this.alertsService = alertsService;
        /**
         * Contains the date of horizon within the view.
         * @private
         */
        _this.horizonDate = moment().startOf('day');
        _this.makeHorizonDateListener(_this.subscriptionPool, router, function (value) {
            _this.horizonDate = value;
            // Ik laat eerst het hoofd scherm refreshen wat dat moet snel.
            // Dus tussen door even niet dit ook refreshen
            // ...even wachten dus.
            window.setTimeout(function () {
                _this.refresh();
            }, 2000);
        });
        _this.makeEntityChangedListener(_this.subscriptionPool, domainService, function (data) {
            if (data.entity.entityType.shortName === 'Availability') {
                _this.refresh();
            }
        });
        return _this;
    }
    Object.defineProperty(InsightAvailableHoursComponent.prototype, "start", {
        /**
         * Gets the start of week with respect to startTimeOffset in weeks
         * @readonly
         * @type {Date}
         */
        get: function () {
            var start = moment(this.horizonDate.toDate()).startOf('isoWeek');
            start.add(this.startOffset, 'week');
            return start.toDate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InsightAvailableHoursComponent.prototype, "finish", {
        /**
         * Gets finish of week with respect to endTimeOffset in weeks
         * @readonly
         * @type {Date}
         */
        get: function () {
            var date = moment(this.horizonDate.toDate()).endOf('isoWeek');
            date.add(this.finishOffset, 'week');
            var finish = date.toDate();
            if (finish > this.publishedTill) {
                finish = this.publishedTill;
            }
            return finish;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InsightAvailableHoursComponent.prototype, "startOffset", {
        /**
         * Gets the offset of the start in weeks relative to the horizon date.
         * @readonly
         * @private
         * @type {number}
         */
        get: function () {
            var offset = 0;
            // Get the offset from the configuration
            if (this.configuration && this.configuration.data && this.configuration.data.startTimeOffset) {
                offset = this.configuration.data.startTimeOffset;
            }
            return offset;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InsightAvailableHoursComponent.prototype, "finishOffset", {
        /**
         * Gets the offset of the finish in weeks relative to the horizon date.
         * @readonly
         * @private
         * @type {number}
         */
        get: function () {
            var offset = 0;
            // Get the offset from the configuration
            if (this.configuration && this.configuration.data && this.configuration.data.endTimeOffset) {
                offset = this.configuration.data.endTimeOffset;
            }
            return offset;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Register component by the insight provider
     */
    InsightAvailableHoursComponent.register = function () {
        ComponentRegistry.register('insight', 'InsightAvailableHoursComponent', InsightAvailableHoursComponent);
    };
    /** Handle for the after items loaded event */
    InsightAvailableHoursComponent.prototype.afterItemsLoaded = function () {
        var _this = this;
        var weeks = [];
        var weekStart = moment(this.start);
        var weekFinish = moment(this.start);
        weekFinish.endOf('isoWeek');
        weeks.push({
            value: 0,
            start: weekStart.toDate(),
            finish: weekFinish.toDate()
        });
        var until = this.finish;
        weekStart.add(1, 'week');
        weekFinish.add(1, 'week');
        while (weekFinish.isBefore(until) || weekFinish.isSame(until)) {
            weeks.push({
                value: 0,
                start: weekStart.toDate(),
                finish: weekFinish.toDate()
            });
            weekStart.add(1, 'week');
            weekFinish.add(1, 'week');
        }
        // Je zou kunnen overwegen dit server side te doen. (Performance?)
        // Maar nu laat je de presentatie logica van de ruwe cijfers over aan de voorkant.
        // Hierdoor meer hergebruik van achterkant meer waarschijnlijk.
        weeks.forEach(function (week) {
            _this.loadedItems.find(function (item) {
                var strt = item['minimum'];
                if (week.finish <= strt) {
                    // Stop met zoeken dit item is al voorbij de week
                    return true;
                }
                var fnsh = item['maximum'];
                if (fnsh <= week.start) {
                    // Je bent er nog niet je moet een item verder
                    return false;
                }
                if (strt < week.start) {
                    // Alleen overlap met week
                    strt = week.start;
                }
                if (fnsh > week.finish) {
                    // Alleen overlap met week.
                    fnsh = week.finish;
                }
                // Volgens mijn ondersteund het model ook maxload <> duration
                // Wordt zelden gebruikt kies hier voor maxload = duration.
                var duration = moment(fnsh).diff(strt, 'milliseconds');
                week.value += duration;
                return false;
            });
        });
        var contract = moment.duration(this.resourceService.resource['ContractHours']).asMinutes();
        // Start with an empty items array
        var items = [];
        // Pre-define x-axis: today and the four days after
        for (var week = 0; week < weeks.length; week += 1) {
            var value = moment.duration(weeks[week].value, 'milliseconds').asMinutes();
            items.push({
                name: this.getAxisLabel(weeks[week].start, contract, value),
                value: this.toDuration(value)
            });
        }
        this.setData(items);
    };
    /**
     * Returns a label for the x-axis based on the date it represents.
     * @param date The date from which a string is derived.
     * @returns The date relative to today, plus day and month.
     */
    InsightAvailableHoursComponent.prototype.getAxisLabel = function (start, contract, value) {
        var date = moment(start);
        var isOK = ' (' + (contract <= value ? this.translateService.instant('APP.INSIGHTS.OK') : this.toDuration(contract)) + ')';
        return this.relativeWeek(date) + isOK;
    };
    /**
     * Returns a string representing the week relative to this week.
     * @param {moment.Moment} date The date from which a string is derived.
     * @returns {string} The week relative to this week.
     */
    InsightAvailableHoursComponent.prototype.relativeWeek = function (date) {
        switch (date.clone().startOf('week').diff(moment().startOf('week'), 'week')) {
            case -1:
                return this.translateService.instant('APP.INSIGHTS.FOOTER.LAST_WEEK');
            case 0:
                return this.translateService.instant('APP.INSIGHTS.FOOTER.THIS_WEEK');
            case 1:
                return this.translateService.instant('APP.INSIGHTS.FOOTER.NEXT_WEEK');
            default:
                return this.translateService.instant('APP.INSIGHTS.WEEK') + ' ' + date.isoWeek();
        }
    };
    /**
     * Returns a string representing the date relative to today.
     * @param {moment.Moment} date The date from which a string is derived.
     * @returns {string} The day relative to today.
     */
    InsightAvailableHoursComponent.prototype.relativeDay = function (date) {
        switch (date.diff(moment().startOf('day'), 'day')) {
            case -1:
                return this.translateService.instant('APP.INSIGHTS.FOOTER.YESTERDAY');
            case 0:
                return this.translateService.instant('APP.INSIGHTS.FOOTER.TODAY');
            case 1:
                return this.translateService.instant('APP.INSIGHTS.FOOTER.TOMORROW');
            default:
                return date.format('L');
        }
    };
    return InsightAvailableHoursComponent;
}(InsightTableComponent));
export { InsightAvailableHoursComponent };
